import Avatar from "components/Avatar/Avatar";
import { CPDPoints } from "components/CPDPoints";
import constants from "constants";
import React from "react";
import { Link } from "react-router";
import WebinarSponsorsRepresentative from "../../WebinarSponsorsRepresentative";
import { connect } from "react-redux";
import { noImagePlaceholder } from "../../../constants/baseConst";
import { apiGetCertificates } from "../../../sagas/webinars";
import { sortExpertsByNumeration } from "utils/sort-experts";

const { API_CERTIFICATES, CPD_STATUSES, SKIP_QUIZ_STATUS, REF_TYPES } =
  constants;

const Webinar = ({
  webinar = {},
  startQuiz,
  token,
  userRole,
  groupId,
  currentGroup: { logo_url, title },
}) => {
  const renderExpertData = () => {
    const experts = sortExpertsByNumeration(webinar.experts);
    if (experts && experts.length) {
      return experts.map((expert) => (
        <div className="player_person clearfix-c">
          <div className="player_person_photo">
            <Avatar
              size={55}
              name={expert.name}
              src={expert.expert_avatar_url}
            />
          </div>
          <div className="player_person_name">
            <p>{expert.name || ""}</p>
          </div>
          <div className="player_person_description">
            <p>
              {`${expert.expert_type || ""}`}・{expert.location || ""}
            </p>
          </div>
        </div>
      ));
    } else {
      return null;
    }
  };
  return (
    <main className="site--width">
      <div className="container_info_player">
        <iframe width="100%" height="250" src={webinar.audio_link} />
        <h4 style={{ textAlign: "center" }}>{webinar.webinar_title}</h4>
        {/* <div style={{ display: "flex", justifyContent: "start" }}>
          <div>
            <img
              className="group-card-image"
              src={logo_url || noImagePlaceholder}
            />
            <h6 style={{ textAlign: "center" }}>{title}</h6>
          </div>
        </div> */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            {renderExpertData()}
          </div>
          <div className="player_logo">
            {webinar.sponsors && webinar.sponsors.length ? (
              webinar.sponsors.map((sponsor) =>
                sponsor.logo_url ? (
                  <img src={sponsor.logo_url} alt="logo" />
                ) : null,
              )
            ) : webinar.sponsor ? (
              webinar.sponsor.logo_url ? (
                <img src={webinar.sponsor.logo_url} alt="logo" />
              ) : null
            ) : null}

            {webinar.sponsors &&
            webinar.sponsors.length &&
            webinar.sponsors.length > 0 ? (
              <div className="sponsor_logo_info clearfix">
                Sponsored by:{" "}
                {webinar.sponsors && webinar.sponsors.length
                  ? webinar.sponsors.map((sponsor) => sponsor.title).join(", ")
                  : webinar.sponsor
                    ? webinar.sponsor.title
                    : "N/A"}
              </div>
            ) : null}
          </div>
        </div>
        {/* {Boolean(
          webinar.sponsor_representative &&
            webinar.sponsor_representative.length
        ) && (
          <div className="col l2">
            <WebinarSponsorsRepresentative
              sponsors={webinar.sponsor_representative}
            />
          </div>
        )} */}
        <div className="webinar_section_feedback">
          <div className="feedback_content"> Leave Feedback </div>
          <div className="section_feedback_description">
            We will be grateful if you leave feedback on this webinar.
          </div>
          <div className="section_feedback_button">
            <button className="container_feedback">
              <Link
                activeClassName={"active"}
                to={`/groups/${groupId}/webinars/${webinar.id}/feedback/${webinar.feedback_form_id}`}
              >
                Leave feedback
              </Link>
            </button>
          </div>
        </div>

        <div className="flex_rec_web">
          <div className="partner_logo">
            {webinar.partnerships && webinar.partnerships.length ? (
              webinar.partnerships.map((partnership) =>
                partnership.logo_url ? (
                  <img src={partnership.logo_url} alt="logo" />
                ) : null,
              )
            ) : webinar.partnership ? (
              webinar.partnership.logo_url ? (
                <img src={webinar.partnership.logo_url} alt="logo" />
              ) : null
            ) : null}

            {webinar.partnerships &&
            webinar.partnerships.length &&
            webinar.partnerships.length > 0 ? (
              <div className="partner_logo_info clearfix">
                Brought to you by:{" "}
                {webinar.partnerships && webinar.partnerships.length
                  ? webinar.partnerships
                      .map((partnership) => partnership.title)
                      .join(", ")
                  : webinar.partnership
                    ? webinar.partnership.title
                    : "N/A"}
              </div>
            ) : null}
          </div>
        </div>
        <div>
          {takeQuiz(userRole, webinar, startQuiz, token)}
          <div className="current_points">
            <CPDPoints webinar={webinar} style={{ fontSize: "14px" }} />
          </div>

          <div className="webinar_status">
            {webinar && webinar.document_url ? (
              <div className="col l1">
                <div className="current_points">
                  Agenda:
                  <a
                    className="download_attachment"
                    target="_blank"
                    href={webinar.document_url}
                  >
                    Download
                  </a>
                </div>
              </div>
            ) : null}
            {/*<p>
                &nbsp; {webinar.is_quiz_completed && !webinar.joined && 'Already completed'}
                &nbsp; {webinar.joined && 'You were present at the webinar, so you do not need to pass the test.'}
              </p>*/}
          </div>
        </div>
      </div>
    </main>
  );
};

const takeQuiz = (userRole, webinar, startQuiz, token) => {
  // if (userRole === 'consultant' || userRole === 'hospital_doctor') {
  //   return;
  // }
  if (
    [SKIP_QUIZ_STATUS.available].indexOf(webinar.cpd_quiz) !== -1 &&
    [CPD_STATUSES.granted, CPD_STATUSES.applied_for].indexOf(
      webinar.cpd_status,
    ) !== -1 &&
    !(webinar.is_quiz_completed || webinar.joined)
  ) {
    return (
      <div className="player_join" onClick={startQuiz}>
        <div className="container_question">
          <a onClick={startQuiz} className="modal-trigger">
            TAKE CPD QUIZ
          </a>
        </div>
      </div>
    );
  }
  if (
    webinar.cpd_status === CPD_STATUSES.granted ||
    webinar.ref_type === REF_TYPES.CERTIFICATE_OF_PARTICIPATION
  ) {
    return (
      <div className="player_download">
        <div className="container_download">
          <a
            onClick={() => apiGetCertificates(webinar.id)}
            className="cursor-pointer"
            target="_blank"
          >
            <p className="section_live_download"></p>
          </a>
          <a
            onClick={() => apiGetCertificates(webinar.id)}
            className="cursor-pointer"
            target="_blank"
          >
            <img
              className="cursor-pointer"
              src="/assets/img/download_zoom.png"
              alt="icon"
            />
          </a>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  currentGroup: state.studygroups.studygroup,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Webinar);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupsUserAudioWebinar/Webinar.jsx